// AddressAutoComplete.tsx
import React, {useState, useEffect} from 'react';
import {Input} from 'antd';
import {LoadScript, StandaloneSearchBox} from '@react-google-maps/api';
import {MAPS_API_KEY} from "../../constants";

const libraries = ['places'];

const AddressAutoComplete = ({value, onSelect, onChange}) => {
    const [searchBox, setSearchBox] = useState(null);

    const [inputValue, setInputValue] = useState("");

    const onChangeInternal = (e) => {
        setInputValue(e.target.value)
        if (onChange) {
            onChange(e.target.value);
        }
    }

    useEffect(() => {
        if (value && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleLoad = (ref) => {
        setSearchBox(ref);
    };

    const handlePlacesChanged = () => {
        const places = searchBox?.getPlaces();
        if (places && places.length > 0) {
            const place = places[0];
            onSelect(place);
            setInputValue(place.formatted_address || place.name);
        }
    };

    return (
        <LoadScript googleMapsApiKey={MAPS_API_KEY} libraries={libraries}>
            <StandaloneSearchBox onLoad={handleLoad} onPlacesChanged={handlePlacesChanged}>
                <Input
                    value={inputValue}
                    onChange={onChangeInternal}
                    placeholder="Vul een adres in en selecteer uit de suggesties"
                    style={{width: '100%'}}
                />
            </StandaloneSearchBox>
        </LoadScript>
    );
};

export default AddressAutoComplete;